import React, { useEffect, useState } from 'react';

import '../assets/scss/rating.scss';
import { observer } from 'mobx-react';
import RatingStore from '../store/RatingStore';
import UserStore from '../store/UserStore';
import Header from '../components/common/Header';
import { formatTime } from '../utils/utils';

function getScoreColor(score: number, maxScore: number) {
  const step = maxScore / 6;
  
  if (score >= maxScore - step * 4 + 1 && score <= maxScore - step * 3)
    return { color: '#1ce400', background: '#084a00' };
  else if (score >= maxScore - step * 3 + 1 && score <= maxScore - step * 2)
    return { color: '#ffc800', background: '#654f00' };
  else if (score >= maxScore - step * 2 + 1 && score <= maxScore - step * 1 - 1000)
    return { color: '#ff6309', background: '#652703' };
  else if (score >= maxScore - step * 1 + 1 - 1000)
    return { color: '#fe1f00', background: '#640b00' };
  else
    return { color: '#eeeeee', background: '#545454' };
}

const Rating: React.FC = observer(() => {
  const [fetched, setFetched] = useState(false);

  useEffect(() => {
    if (!fetched) {
      RatingStore.fetchMaps();
      RatingStore.fetchUsers();
      setFetched(true);
    }
  }, [fetched, setFetched]);

  return (
    <>
      <Header />
      <div className="container">
        <div className="rating-btns">
          <button className={RatingStore.rating == "Assetto Corsa" ? 'rating-btn selected' : 'rating-btn'} onClick={() => RatingStore.setRating("Assetto Corsa")}>Assetto Corsa</button>
          <button className={RatingStore.rating == "Warpoint" ? 'rating-btn selected' : 'rating-btn'} onClick={() => RatingStore.setRating("Warpoint")}>WARPOINT Arena</button>
          <button className={RatingStore.rating == "Beat Saber" ? 'rating-btn selected' : 'rating-btn'} onClick={() => RatingStore.setRating("Beat Saber")}>Beat Saber</button>
        </div>
      </div>
      {RatingStore.rating === "Assetto Corsa" ?
      <>
        <div className="rating">
        <div className="container">
          <div className="rating_inner">
            <div className="rating_list">
              {RatingStore.users.map((user, index) => {
                const colors = getScoreColor(user.Score, 15000);

                return <div className="rating_item" key={user.UserID.toString()}>
                  <div className="rating_item-header" onClick={() => user.Opened = !user.Opened }>
                    <p>{index+1}</p>
                    <p>{user.NickName !== '' ? user.NickName : user.ShortID} {user.UserID === UserStore.id ? '(Вы)' : null}</p>
                    <div className="score" style={{ background: colors.background }}>
                      <div className="lines">
                        <div className="line" style={{ background: colors.color }} />
                        <div className="line" style={{ background: colors.color, marginLeft: '.125rem' }} />
                      </div>
                      <div
                        className="value"
                        style={{
                          color: colors.color,
                          textWrap: 'nowrap'
                        }}
                      >
                        {(Math.floor(user.Score * 10) / 10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace('.', ',')}
                      </div>
                    </div>
                  </div>
                  <div className="rating_item-body" style={{ display: user.Opened ? 'block' : 'none' }}>
                    <ul>
                      {RatingStore.maps.map((map) => {
                        const userMap = user.Maps.find(x => x.ID === map.ID);
                        return (
                          <div className='rating_item-body_item' key={map.Title}>
                            <div className='rating_item-body_map'>{map.Title}</div>
                            <div className='rating_item-body_time'>{formatTime(userMap?.Time)}</div>
                          </div>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              })}
            </div>
            <table className="rating_table">
              <thead>
                <tr className="rating_table-header">
                  <th style={{ width: '128px' }}>Рейтинг</th>
                  <th style={{ textAlign: 'left' }}>Игрок</th>
                  {RatingStore.maps.map((map, index) => {
                    return (
                      <th key={map.ID} style={{ width: '300px' }}>
                        {map.Title}
                        <br />
                        {index === 0 ?
                          <div className="difficulty-block">
                            <div className="difficulty easy" />
                          </div> :
                          <></>
                        }
                        {index === 1 ?
                          <div className="difficulty-block">
                            <div className="difficulty medium" />
                            <div className="difficulty medium" />
                          </div> :
                          <></>
                        }
                        {index === 2 ?
                          <div className="difficulty-block">
                            <div className="difficulty hard" />
                            <div className="difficulty hard" />
                            <div className="difficulty hard" />
                          </div> :
                          <></>
                        }
                      </th>
                    );
                  })}
                  <th style={{ width: '140px' }}>Очки</th>
                </tr>
              </thead>
            </table>
            <div className="table-body">
              <table className="rating_table">
                <tbody>
                  {RatingStore.users.map((user, index) => {
                    const colors = getScoreColor(user.Score, 15000);

                    return <tr className="rating_table-row" style={{ background: user.UserID === UserStore.id ? 'var(--sr--color_background_secondary)' : '' }} key={user.UserID.toString()}>
                      <td className="table_column-rank">{index+1}</td>
                      <td  className="table_column-name">{user.NickName !== '' ? user.NickName : user.ShortID} {user.UserID === UserStore.id ? '(Вы)' : null}</td>
                      {RatingStore.maps.map((map) => {
                        const userMap = user.Maps.find(x => x.ID === map.ID);
                        return (
                          <td style={{ width: '300px' }} key={map.Title}>{formatTime(userMap?.Time)}</td>
                        );
                      })}
                      <td style={{ width: '140px' }}>
                        <div className="score" style={{ background: colors.background }}>
                          <div className="lines">
                            <div className="line" style={{ background: colors.color }} />
                            <div className="line" style={{ background: colors.color, marginLeft: '.125rem' }} />
                          </div>
                          <div
                            className="value"
                            style={{
                              color: colors.color,
                              textWrap: 'nowrap'
                            }}
                          >
                            {(Math.floor(user.Score * 10) / 10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace('.', ',')}
                          </div>
                        </div>
                      </td>
                    </tr>
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div></> : <></>
      }

      {RatingStore.rating === "Warpoint" ?
        <>
        <div className="rating">
          <div className='rating-btns'>
            <button className={RatingStore.isTeam ? 'rating-btn selected' : 'rating-btn'} style={{ width: '150px', height: '32px' }} onClick={() => RatingStore.isTeam = true}>Командный</button>
            <button className={!RatingStore.isTeam ? 'rating-btn selected' : 'rating-btn'} style={{ width: '150px', height: '32px' }} onClick={() => RatingStore.isTeam = false}>Личный</button>
          </div>
          {!RatingStore.isTeam ? <div className="about-header" style={{ background: 'none' }}>
          <div className="container">
            <div className="about-header_inner">
              <div className="about-header_info">
                <div className="about-header_info-content">
                  <h3 className="about-header_info-title">Турнир по игре WARPOINT Arena</h3>
                  <p className="about-header_info-description about-date">Дата окончания турнира: <b>01.08.2025</b></p>
                  <br />
                  <p className="about-header_info-description">Подробности можно узнать у <span style={{ color: 'red' }}><b>Администратора</b></span>.</p>
                  <p className="about-header_info-description">Или по телефону: <br/><div className='padding'>{'\u00A0\u00A0\u00A0\u00A0'}</div><b>+7 (3953) 480-183</b> <span className='mini'>(WARPOINT | ул. Курчатова, 2Г)</span></p>
                </div>
              </div>
              <div className="divider" />
              <div className="about-header_info prize-fund">
                <div className="about-header_info-prize-fund">
                <h3 className="about-header_info-title" style={{ fontSize: '32px', color: 'var(--sr--color_text_tertiary)' }}>Текущий призовой фонд</h3>
                <h1 className="about-header_info-amount" style={{ textAlign: 'right', width: '100%' }}>{((15000+Math.round(Math.floor(15000-((((new Date('2025-06-30')) as any -(new Date(Date.now()) as any) as any)/ (1000 * 60 * 60 * 24))*214.2857142857143))/100)*100) > 30000 ? 30000 : 15000+Math.round(Math.floor(15000-((((new Date('2025-06-30')) as any -(new Date(Date.now()) as any) as any)/ (1000 * 60 * 60 * 24))*214.2857142857143))/100)*100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}₽</h1>
                </div>
              </div>
            </div>
          </div>
        </div> : <></>}
        {!RatingStore.isTeam ? <center><p>Формула расчета очков: <b><code style={{ whiteSpace: 'nowrap' }}>СКУ * (Убийства / Смерти) * 400</code></b></p><br /></center> : <></>}
          <div className="container">
            <div className="rating_inner">
              <div className="rating_list">
                {RatingStore.isTeam ?
                  RatingStore.warpoint.filter(x => x.IsTeam).map((user, index) => {
                    if (user.IsTeam) {
                      console.log(user);
                    const colors = getScoreColor(user.Score, 15000);

                    return <div className="rating_item" style={{backgroundColor: (index < 8) ? ((index % 2 === 0) ? '#163800' : '#112b00') : ''}} key={user.UserID.toString()}>
                      <div className="rating_item-header" onClick={() => user.Opened = !user.Opened }>
                        <p>{index+1}</p>
                        <p>{user.NickName !== '' ? user.NickName : user.ShortID} {user.UserID === UserStore.id ? '(Вы)' : null}</p>
                        <div className="score" style={{ background: colors.background }}>
                          <div className="lines">
                            <div className="line" style={{ background: colors.color }} />
                            <div className="line" style={{ background: colors.color, marginLeft: '.125rem' }} />
                          </div>
                          <div
                            className="value"
                            style={{
                              color: colors.color,
                              textWrap: 'nowrap'
                            }}
                          >
                            {(Math.floor(user.Score * 10) / 10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace('.', ',')}
                          </div>
                        </div>
                      </div>
                      <div className="rating_item-body" style={{ display: user.Opened ? 'block' : 'none' }}>
                        <ul>
                          <div className='rating_item-body_item'>
                            <div className='rating_item-body_map'>СКУ</div>
                            <div className='rating_item-body_time'>{Math.floor(user.AVG * 100) / 100}</div>
                          </div>
                          <div className='rating_item-body_item'>
                            <div className='rating_item-body_map'>Убийства</div>
                            <div className='rating_item-body_time'>{user.Kills}</div>
                          </div>
                          <div className='rating_item-body_item'>
                            <div className='rating_item-body_map'>Смерти</div>
                            <div className='rating_item-body_time'>{user.Deaths}</div>
                          </div>
                          <div className='rating_item-body_item'>
                            <div className='rating_item-body_map'>У/С</div>
                            <div className='rating_item-body_time'>{Math.floor(user.KD * 100) / 100}</div>
                          </div>
                        </ul>
                      </div>
                    </div>
                    }
                    
                  }) :
                  RatingStore.warpoint.filter(x => !x.IsTeam).map((user, index) => {
                    if (!user.IsTeam) {
                      console.log(user);
                      const colors = getScoreColor(user.Score, 35000);
  
                      return <div className="rating_item" key={user.UserID.toString()}>
                        <div className="rating_item-header" onClick={() => user.Opened = !user.Opened }>
                          <p>{index+1}</p>
                          <p>{user.NickName !== '' ? user.NickName : user.ShortID} {user.UserID === UserStore.id ? '(Вы)' : null}</p>
                          <div className="score" style={{ background: colors.background }}>
                            <div className="lines">
                              <div className="line" style={{ background: colors.color }} />
                              <div className="line" style={{ background: colors.color, marginLeft: '.125rem' }} />
                            </div>
                            <div
                              className="value"
                              style={{
                                color: colors.color,
                                textWrap: 'nowrap'
                              }}
                            >
                              {(Math.floor(user.Score * 10) / 10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace('.', ',')}
                            </div>
                          </div>
                        </div>
                        <div className="rating_item-body" style={{ display: user.Opened ? 'block' : 'none' }}>
                          <ul>
                            <div className='rating_item-body_item'>
                              <div className='rating_item-body_map'>СКУ</div>
                              <div className='rating_item-body_time'>{Math.floor(user.AVG * 100) / 100}</div>
                            </div>
                            <div className='rating_item-body_item'>
                              <div className='rating_item-body_map'>Убийства</div>
                              <div className='rating_item-body_time'>{user.Kills}</div>
                            </div>
                            <div className='rating_item-body_item'>
                              <div className='rating_item-body_map'>Смерти</div>
                              <div className='rating_item-body_time'>{user.Deaths}</div>
                            </div>
                            <div className='rating_item-body_item'>
                              <div className='rating_item-body_map'>У/С</div>
                              <div className='rating_item-body_time'>{Math.floor(user.KD * 100) / 100}</div>
                            </div>
                          </ul>
                        </div>
                      </div>
                    }
                    
                  })
                }
              </div>
              <table className="rating_table">
                <thead>
                  <tr className="rating_table-header">
                    <th style={{ width: '128px' }}>Рейтинг</th>
                    <th style={{ textAlign: 'left' }}>&nbsp;&nbsp;&nbsp;&nbsp;Игрок</th>
                    <th style={{ width: '120px' }}>СКУ</th>
                    <th style={{ width: '160px' }}>Убийства</th>
                    <th style={{ width: '160px' }}>Смерти</th>
                    <th style={{ width: '100px' }}>У/С</th>
                    <th style={{ width: '140px' }}>Очки</th>
                  </tr>
                </thead>
              </table>
              <div className="table-body">
                <table className="rating_table">
                  <tbody>
                    {RatingStore.isTeam ? RatingStore.warpoint.filter(x => x.IsTeam).map((user, index) => {
                      if (!user.IsTeam) return;
                      const colors = getScoreColor(user.Score, 15000);

                      return <tr className="rating_table-row" style={{ backgroundColor: (index < 8) ? ((index % 2 === 0) ? '#163800' : '#112b00') : ''}} key={user.UserID.toString()}>
                        <td className="table_column-rank">{index+1}</td>
                        <td className="table_column-name">{user.NickName !== '' ? user.NickName : user.ShortID} {user.UserID === UserStore.id ? '(Вы)' : null}</td>
                        <td style={{ width: '120px' }}>{Math.floor(user.AVG * 100) / 100}</td>
                        <td className="table_column-kd">{user.Kills}</td>
                        <td className="table_column-kd">{user.Deaths}</td>
                        <td style={{ width: '100px' }}>{Math.floor(user.KD * 100) / 100}</td>
                        <td style={{ width: '140px' }}>
                          <div className="score" style={{ background: colors.background }}>
                            <div className="lines">
                              <div className="line" style={{ background: colors.color }} />
                              <div className="line" style={{ background: colors.color, marginLeft: '.125rem' }} />
                            </div>
                            <div
                              className="value"
                              style={{
                                color: colors.color,
                                textWrap: 'nowrap'
                              }}
                            >
                              {(Math.floor(user.Score * 10) / 10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace('.', ',')}
                            </div>
                          </div>
                        </td>
                      </tr>
                    }) : RatingStore.warpoint.filter(x => !x.IsTeam).map((user, index) => {
                      if (user.IsTeam) return;
                      const colors = getScoreColor(user.Score, 35000);

                      return <tr className="rating_table-row" style={{ background: user.UserID === UserStore.id ? 'var(--sr--color_background_secondary)' : '' }} key={user.UserID.toString()}>
                        <td className="table_column-rank">{index+1}</td>
                        <td className="table_column-name">{user.NickName !== '' ? user.NickName : user.ShortID} {user.UserID === UserStore.id ? '(Вы)' : null}</td>
                        <td style={{ width: '120px' }}>{Math.floor(user.AVG * 100) / 100}</td>
                        <td className="table_column-kd">{user.Kills}</td>
                        <td className="table_column-kd">{user.Deaths}</td>
                        <td style={{ width: '100px' }}>{Math.floor(user.KD * 100) / 100}</td>
                        <td style={{ width: '140px' }}>
                          <div className="score" style={{ background: colors.background }}>
                            <div className="lines">
                              <div className="line" style={{ background: colors.color }} />
                              <div className="line" style={{ background: colors.color, marginLeft: '.125rem' }} />
                            </div>
                            <div
                              className="value"
                              style={{
                                color: colors.color,
                                textWrap: 'nowrap'
                              }}
                            >
                              {(Math.floor(user.Score * 10) / 10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace('.', ',')}
                            </div>
                          </div>
                        </td>
                      </tr>
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div></> : <></>
      }

      {RatingStore.rating === "Beat Saber" ?
       <>
       <div className="about-header" style={{ background: 'none' }}>
          <div className="container">
            <div className="about-header_inner">
              <div className="about-header_info">
                <div className="about-header_info-content">
                  <h3 className="about-header_info-title">Турнир по игре Beat Saber</h3>
                  <p className="about-header_info-description about-date">Дата окончания турнира: <b>01.08.2025</b></p>
                  <br />
                  <p className="about-header_info-description">Подробности можно узнать у <span style={{ color: 'red' }}><b>Администратора</b></span>.</p>
                  <p className="about-header_info-description">Или по телефону: <br /><p><div className='padding'>{'\u00A0\u00A0\u00A0\u00A0'}</div><b>+7 (3953) 200-175</b> <span className='mini'>(Another World | ул. Наймушина, 7)</span></p><p><div className='padding'>{'\u00A0\u00A0\u00A0\u00A0'}</div><b>+7 (3953) 480-183</b> <span className='mini'>(WARPOINT | ул. Курчатова, 2Г)</span></p></p>
                </div>
              </div>
              <div className="divider" />
              <div className="about-header_info prize-fund">
                <div className="about-header_info-prize-fund">
                <h3 className="about-header_info-title" style={{ color: 'var(--sr--color_text_tertiary)' }}>Текущий призовой фонд</h3>
                <h1 className="about-header_info-amount" style={{ textAlign: 'right', width: '100%' }}>{((5000+Math.round(Math.floor(10000-((((new Date('2025-05-31')) as any -(new Date(Date.now()) as any) as any)/ (1000 * 60 * 60 * 24))*270.2702702702703))/100)*100) > 15000 ? 15000 : 5000+Math.round(Math.floor(10000-((((new Date('2025-05-31')) as any -(new Date(Date.now()) as any) as any)/ (1000 * 60 * 60 * 24))*270.2702702702703))/100)*100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}₽</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="rating">
          <div className="container">
            <div className="rating_inner">
              <div className="rating_list">
                {RatingStore.beatsaber.map((user, index) => {
                  const colors = getScoreColor(user.Score, 150000);

                  return <div className="rating_item" key={user.UserID.toString()}>
                    <div className="rating_item-header" onClick={() => user.Opened = !user.Opened }>
                      <p>{index+1}</p>
                      <p>{user.NickName !== '' ? user.NickName : user.ShortID} {user.UserID === UserStore.id ? '(Вы)' : null}</p>
                      <div className="score" style={{ background: colors.background }}>
                        <div className="lines">
                          <div className="line" style={{ background: colors.color }} />
                          <div className="line" style={{ background: colors.color, marginLeft: '.125rem' }} />
                        </div>
                        <div
                          className="value"
                          style={{
                            color: colors.color,
                            textWrap: 'nowrap'
                          }}
                        >
                          {(Math.floor(user.Score * 10) / 10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace('.', ',')}
                        </div>
                      </div>
                    </div>
                  </div>
                })}
              </div>
              <table className="rating_table">
                <thead>
                  <tr className="rating_table-header">
                    <th style={{ width: '128px' }}>Рейтинг</th>
                    <th style={{ textAlign: 'left' }}>&nbsp;&nbsp;&nbsp;&nbsp;Игрок</th>
                    <th style={{ width: '180px' }}>Очки</th>
                  </tr>
                </thead>
              </table>
              <div className="table-body">
                <table className="rating_table">
                  <tbody>
                    {RatingStore.beatsaber.map((user, index) => {
                      const colors = getScoreColor(user.Score, 150000);

                      return <tr className="rating_table-row" style={{ background: user.UserID === UserStore.id ? 'var(--sr--color_background_secondary)' : '' }} key={user.UserID.toString()}>
                        <td className="table_column-rank">{index+1}</td>
                        <td className="table_column-name">{user.NickName !== '' ? user.NickName : user.ShortID} {user.UserID === UserStore.id ? '(Вы)' : null}</td>
                        <td style={{ width: '180px' }}>
                          <div className="score" style={{ background: colors.background }}>
                            <div className="lines">
                              <div className="line" style={{ background: colors.color }} />
                              <div className="line" style={{ background: colors.color, marginLeft: '.125rem' }} />
                            </div>
                            <div
                              className="value"
                              style={{
                                color: colors.color,
                                textWrap: 'nowrap'
                              }}
                            >
                              {(Math.floor(user.Score * 10) / 10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace('.', ',')}
                            </div>
                          </div>
                        </td>
                      </tr>
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div></> : <></>
      }
      
    </>
  );
});

export default Rating;